import { TextValide } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2ChatEvent } from "../../../event/Poker2ChatEvent";
import { Poker2Command } from "../Poker2Command";

export class TCHCommand extends Poker2Command {
    protected get cmdId(): string {
        return "tch";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            var chatPlayerId: number = int(paramObj.playerId);
            var chatMsg: string = TextValide.parseChatMessage(paramObj.text);
            var name: string = paramObj.name;
            var isMod: boolean = paramObj.isMod;
            var spec: boolean = paramObj.spec;
            this.controller.dispatchEvent(new Poker2ChatEvent("addmsg", chatPlayerId, -1, chatMsg, name, isMod, spec));
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
